module.exports = __webpack_public_path__ + "static/logowhite-2ac75ec8b9f347c856383ca2e16a0ac9.png";